import { render, staticRenderFns } from "./BTFooter.vue?vue&type=template&id=9b2f4aa0&scoped=true&"
import script from "./BTFooter.vue?vue&type=script&lang=js&"
export * from "./BTFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2f4aa0",
  null
  
)

export default component.exports